import {Injectable, Injector} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CacheResolveService} from "../services/cache-resolve.service";
const TIME_TO_LEAVE = 0
@Injectable()
export class CacheInterceptorInterceptor implements HttpInterceptor {

  constructor( private injector:Injector) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const cacheResolverService = this.injector.get(CacheResolveService);
    const forcerefresh = req.headers.get('forcerefresh') === 'true';
    if (forcerefresh) {
      const headers = req.headers.delete('forcerefresh');
      req = req.clone({headers});
      return next.handle(req);
    }
    if (req.method === 'GET' || (req.method === 'POST' && cacheResolverService.allowedPostRoutes.includes(req.url))) {
      // Utilisez le service de cache ici, les logs sont déjà ajoutés dans le service de cache.
      return cacheResolverService.getOrSetResponse(req, TIME_TO_LEAVE, () => next.handle(req));
    }

    // console.log(`[Pass-through] Requête non mise en cache pour ${req.method}: ${req.urlWithParams}`);
    return next.handle(req);
  }

}
